export class User{
  private _id: number;
  private _name: string;
  private _email: string;
  private _sid: string;
  private _isActive: boolean;
  private _admin: boolean;

  constructor(id: number = 0,
              name: string = "",
              email: string = "",
              sid: string = "",
              isActive: boolean = false,
              admin: boolean = false
              ) {
    this._id = id;
    this._name = name;
    this._email = email;
    this._sid = sid;
    this._isActive = isActive;
    this._admin = admin;
  }


  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get email(): string {
    return this._email;
  }

  set email(value: string) {
    this._email = value;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  set isActive(value: boolean) {
    this._isActive = value;
  }

  get sid(): string {
    return this._sid;
  }

  set sid(value: string) {
    this._sid = value;
  }

  get admin(): boolean {
    return this._admin;
  }

  set admin(value: boolean) {
    this._admin = value;
  }

  fromJson(json:string){
    let obj = JSON.parse(json);
    this._id = obj._id;
    this._email = obj._email;
    this._name = obj._name;
    this._isActive = obj._isActive;
    this._sid = obj._sid;
    this._admin = obj._admin === true;
    obj = null;
    return this;
  }
}
